import moment from "moment";
import React from "react";
const CourseCompletionTitle= ({ courseCompletionData }) => {
    const { updatedBy, updatedOn } = courseCompletionData || {};
    const updateOnDate = updatedOn ? moment(updatedOn).format('DD MMM,YYYY') : '';
    const updatedOnTime = updatedOn ? moment(updatedOn).format('hh:mm A') : '';
    return (
        <div className="d-flex flex-column m-2" style={{gap:'6px'}}>
           <div className="semi-bolder color-black">Auto-initiate refunds is disabled</div>
           <div className="regular-bold color-black">If there are students left for processing, use the multi-type refund</div>
           <div className="p-2 regular-small color-black" style={{background:'#F5F5F5'}}>
            Last initiated by {updatedBy} on {updateOnDate} at {updatedOnTime}
           </div>
        </div>
    )
}
export default CourseCompletionTitle;